function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback } from 'react';

/**
 * Returns a callback that can update a prop on an object. The update is done
 * by making a copy of the original object with an updated version of the prop
 * and passing the copy to a callback function.
 *
 * e.g.
 * const [value, setValue] = useState({
 *   first: 'John',
 *   last: 'Doe'
 * });
 *
 * const onLastNameChange = usePropChangeCallback(
 *   value,
 *   'last',
 *   setValue
 * );
 *
 * // This will create a new object { first: 'John', last: 'Smith' } and pass it to `setValue`
 * onLastNameChange('Smith');
 *
 * The optional `defaultValue` controls the callback signature. If provided, the
 * callback will support passing in null or undefined values.
 *
 * e.g.
 *
 * const onLastNameChange = usePropChangeCallback(
 *   value,
 *   'last',
 *   setValue,
 *   ''
 * );
 *
 * onLastNameChange('Smith');   // { first: 'John', last: 'Smith' }
 * onLastNameChange(null);      // { first: 'John', last: '' }
 * onLastNameChange(undefined); // { first: 'John', last: '' }
 *
 * @param value The object to update
 * @param propName The prop name to update
 * @param onChange A callback to pass the newly created object with updated prop value
 * @param defaultValue Optional default value. If provided, the returned callback
 * signature will allow null or undefined values to be passed in.
 */

export function usePropChangeCallback(value, propName, onChange, defaultValue) {
  var hasDefault = arguments.length === 4;
  return useCallback(propValue => {
    var newValue = hasDefault ? propValue !== null && propValue !== void 0 ? propValue : defaultValue : propValue;
    onChange(_objectSpread(_objectSpread({}, value), {}, {
      [propName]: newValue
    }));
  }, [onChange, value, propName, hasDefault, defaultValue]);
}
export default usePropChangeCallback;
//# sourceMappingURL=usePropChangeCallback.js.map